import React from "react";
import {withStyles} from "@material-ui/core";

import Card from "components/Card/Card.js";
import Button from "components/CustomButtons/Button.js";

import GridListTile from '@material-ui/core/GridListTile';


import pricingStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/pricingStyle.js";

import CardBody from "../../components/Card/CardBody";
import intl from 'react-intl-universal';



function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}

class UserPromeItem extends React.Component {


	constructor(props, context) {
		super(props, context);

	}




	render() {
		const {classes} = this.props;
		const data = this.props.data;


		return (
			<GridListTile style={{maxWidth: '195px', paddingRight: '12px'}}>
				{/*<img src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/logo_avatar.jpeg'} alt={''}*/}
				{/*style={{width: '200px', height: '200px'}}/>*/}
				<Card pricing>
					<CardBody pricing>
						<div className={classes.iconWrapper}
							 style={{
								 display: 'flex',
								 justifyContent: 'center',
								 alignItems: 'center'
							 }}
						>
							<div style={{
								width: '100px',
								height: '100px',
								borderRadius: '100px',
								backgroundColor: '#ffa726',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}>
								<b style={{
									color: '#fff',
									fontSize: '16pt'
								}}>
									-{this.props.data.prome}%
								</b>
							</div>
						</div>
						<h4
							className={
								  " " + classes.marginTop20
							}
							color={'white'}
						>
							{this.props.data.promeCode}
						</h4>
						<p className={classes.cardDescription}>
							{intl.get('in_any_product')}
						</p>
						{this.props.data.canUse ?
							<Button round color="info" href={"/plans"}>
								{intl.get('go_use')}
							</Button>:
							<Button round disabled>
								{intl.get('is_use')}
							</Button>
						}

					</CardBody>
				</Card>


			</GridListTile>
		);
	}
}

export default withStyles(pricingStyle)(UserPromeItem)